import { render, staticRenderFns } from "./BookingAmendedConfirm.vue?vue&type=template&id=c0ed3fa4"
import script from "./BookingAmendedConfirm.vue?vue&type=script&lang=js"
export * from "./BookingAmendedConfirm.vue?vue&type=script&lang=js"
import style0 from "./BookingAmendedConfirm.vue?vue&type=style&index=0&id=c0ed3fa4&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0ed3fa4')) {
      api.createRecord('c0ed3fa4', component.options)
    } else {
      api.reload('c0ed3fa4', component.options)
    }
    module.hot.accept("./BookingAmendedConfirm.vue?vue&type=template&id=c0ed3fa4", function () {
      api.rerender('c0ed3fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/BookingAmendedConfirm.vue"
export default component.exports